import { authHeader } from "@roman/shared/lib/auth/authHeader";
import romanApi, { type RomanApiError } from "@roman/shared/lib/net/romanApi";
import useSWRMutation, { type SWRMutationConfiguration } from "swr/mutation";

type EditCommentInput = {
  predictionMarketId: string;
  commentId: string;
  text: string;
  mentionedUserIds?: string[];
};

// Backend returns 204 No Content, so no response body
const fetcher = async (_url: string, { arg }: { arg: EditCommentInput }): Promise<void> => {
  const headers = authHeader.getOrThrow();
  return romanApi.put<void, Omit<EditCommentInput, "predictionMarketId" | "commentId">>(
    `/prediction-market/${arg.predictionMarketId}/comments/${arg.commentId}`,
    {
      text: arg.text,
      mentionedUserIds: arg.mentionedUserIds || [],
    },
    { headers },
  );
};

export const useEditComment = (
  swrOptions?: SWRMutationConfiguration<void, RomanApiError, string, EditCommentInput>,
) => {
  const { trigger, error, isMutating } = useSWRMutation<void, RomanApiError, string, EditCommentInput>(
    "edit-comment",
    fetcher,
    swrOptions,
  );

  return {
    editComment: trigger,
    isMutating,
    error,
  };
};
